const BASE62_ALPHABET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

// 6 base62 chars from the timestamp plus 4 from crypto random.
// Ids sort by creation time. 62^6 milliseconds lasts past year 3700.
export function genSortableID(): string {
  const timestamp = Date.now();
  const random = crypto.getRandomValues(new Uint32Array(1))[0] as number;
  return uintToBase62(timestamp, 6) + uintToBase62(random >>> 0, 4);
}

function uintToBase62(num: number, width: number): string {
  let result = "";
  let remaining = num;
  for (let i = 0; i < width; i++) {
    const value = remaining % 62;
    result = BASE62_ALPHABET[value] + result;
    remaining = Math.floor(remaining / 62);
  }
  return result;
}
